<template>
	<div>
		<el-form ref="form" label-width="80px">
			<el-form-item label="角色名称">
				<el-input v-model="name" placeholder="" class="w-50"></el-input>
			</el-form-item>

			<el-form-item label="权限分配">

				<div class="ml-3">
					<el-tabs v-model="activeName">

						<el-tab-pane v-for="(top,top_key) in cities" :key="top_key" :label="top.name" :name="top.name">
							<div class="border py-2 px-3 mb-2 rounded" v-for="(item,two_key) in top.list" :key="two_key">
								<el-checkbox border :indeterminate="item.isIndeterminate" v-model="item.checkAll" @change="handleCheckAllChange($event,top_key,two_key)">{{item.name}}</el-checkbox>

								<div style="margin-left: 50px;margin-top: 10px;">
									<el-checkbox-group v-model="item.checkedCities" @change="handleCheckedCitiesChange($event,top_key,two_key)">
										<el-checkbox border v-for="(val,index2) in item.list" :label="val.id" :key="index2">
											{{val.name}}</el-checkbox>
									</el-checkbox-group>
								</div>

							</div>
						</el-tab-pane>
					</el-tabs>
				</div>




			</el-form-item>
		</el-form>

		<div class="position-fixed" style="flex-direction: column;bottom: 30px;right: 30px;">
			<div class="mb-3">
				<el-button type="success" size="medium" @click="submit">保存</el-button>
			</div>
			<div>
				<el-button type="info" size="medium" @click="toBack">取消</el-button>
			</div>

		</div>
	</div>
</template>

<script>
	export default {
		inject: ['layout'],
		data() {
			return {
				id:0,
				name: "",
				cities: [],
				activeName: ''
			}
		},
		created() {
			this.getParams()
			
			
		},
		methods: {
			getParams() {
				let data = this.$route.query
				
				if(data.item){
					this.id = data.item.id
					this.name = data.item.name
				}
				this.__init()
				// 将数据放在当前组件的数据内
				//this.mallInfo.searchMap.mallCode = routerParams;
				//this.keyupMallName()
			},
			toBack() {
				this.$router.go(-1);
			},
			submit() {
				if (this.name == '') {
					this.$notify.error({
						title: '错误',
						message: '角色名称不能为空'
					});
					return
				}
				let chooseList = [];
				let two = []
				chooseList = this.cities.map(item => {
					return item.list.map(v => {
						two = []
						two = v.checkedCities.map(val => val)
						if (v.isIndeterminate == true || v.checkAll === true) two.push(v.id)
						return two
					})
				})

				console.log(chooseList);
				this.axios.post('/admin/user/addRule', {
					name: this.name,
					id:this.id,
					rule: chooseList
				}, {
					token: true,
					loading: true
				}).then(res => {
					let list = res.data

					if (list.code == 1) {
						this.$message.success(list.msg);
						this.$router.go(-1);
					} else {
						this.$message.error(list.msg);
					}
				})

			},
			__init() {
				this.layout.loading = true;
				this.axios.post('/admin/user/rulePage', {
					id:this.id
				}, {
					token: true,
					loading: true
				}).then(res => {
					let list = res.data

					console.log(list.data.list);
					this.activeName = list.data.list[0].name
					this.cities = list.data.list.map(item => {
						let two = item.child.map(v => {
							return {
								checkAll: v.is_all,
								isIndeterminate: v.is_self,
								checkedCities: v.rule_list,
								name: v.name,
								id: v.id,
								list: v.child
							}
						})

						return {
							id: item.id,
							name: item.name,
							list: two
						}
					})

					this.layout.loading = false;
				}).catch(err => {
					// 失败
					console.log(err);
					this.layout.loading = false;
				})

			},
			handleCheckAllChange(val, top_key, two_key) {
				this.cities[top_key].list[two_key].checkedCities = val ? this.cities[top_key].list[two_key].list.map(item => item.id) :
					[];
				this.cities[top_key].list[two_key].isIndeterminate = false;

			},
			handleCheckedCitiesChange(value, top_key, two_key) {
				let checkedCount = value.length;
				this.cities[top_key].list[two_key].checkAll = checkedCount === this.cities[top_key].list[two_key].list.length;
				this.cities[top_key].list[two_key].isIndeterminate = checkedCount > 0 && checkedCount < this.cities[top_key].list[
					two_key].list.length;
			}
		}
	}
</script>

<style>
</style>
